<template>
  <div class="tw:flex tw:items-center tw:bg-white tw:py-2 tw:pl-4 tw:gap-2" :class="sizeClass">
    <Search class="tw:size-[17px]" />
    <label class="visually-hidden" :for="id">Search</label>
    <input
      :id="id"
      type="search"
      class="tw:focus:outline-0 tw:grow"
      :placeholder="placeholder"
      :value="value"
      @input="emit('onInput', $event.target.value)"
    />
  </div>
</template>

<script setup>
import Search from '@/components/icons/Search.svg?component'
import { computed } from 'vue'

const emit = defineEmits(['onInput'])
const props = defineProps({
  id: {
    type: String,
    required: true,
    default: 'search-field',
  },
  placeholder: {
    type: String,
    required: false,
    default: '',
  },
  value: {
    type: String,
    required: false,
    default: '',
  },
  size: {
    type: String,
    default: 'big',
  },
})

const sizeClass = computed(() => {
  if (props.size === 'medium') return 'tw:pr-4 box-size-36 tw:text-sm tw:rounded-lg '
  else return 'tw:pr-6 box-size-44 tw:text-base tw:rounded-lg'
})
</script>
